import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { defaultTrailerType, trailerTypes } from "@/utils/constants";
import { Dropdown } from "@/components/common/inputs";
import { setTrailerType } from "@/state/searchInputSlice";
import { useQuery } from "@/utils/query";
import { useLocation } from "react-router";
import { setCurrentSearch } from "@/state/currentSearchSlice";

export const TrailerTypeInput = ({ disabled = false }) => {
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.profile);
    const { trailerType } = useSelector((state) => state.searchInput);
    const { trailerType: queryTrailerType } = useQuery();
    const location = useLocation();

    const handleSetTrailer = (id) => {
        dispatch(setTrailerType(trailerTypes.find((t) => t.id === id)));
    };

    useEffect(() => {
        const initialTrailerType = queryTrailerType
            ? trailerTypes.find((t) => t.id === queryTrailerType)
            : profile.data?.trailerType
              ? profile.data.trailerType
              : defaultTrailerType;
        dispatch(setTrailerType(initialTrailerType));
        dispatch(setCurrentSearch({ trailerType: initialTrailerType }));
        // Clearing done via SearchInputs clear
    }, [location.pathname, queryTrailerType]);

    return (
        <Dropdown
            className="w-full mb-1 md:mb-0 md:mr-1 md:max-w-[200px] rounded-tl-lg rounded-tr-lg md:rounded-tr-none md:rounded-l-lg"
            items={trailerTypes}
            value={trailerType}
            setValue={handleSetTrailer}
            label="Trailer type"
            minWidth={200}
            disabled={disabled}
        />
    );
};
